// 246 211 19 / #F60313
// 214 175 22 / #D6AF16
// 222 184 23 / #DEB817

export default ['#F60313', '#D6AF16', '#DEB817']
